export const IWeeklyHours = Object.freeze({
  hours: "hours",
  fluctuating: "fluctuating",
});

export class WeeklyHoursModel {
  constructor(data = {}) {
    this[IWeeklyHours.hours] = data[IWeeklyHours.hours];
    this[IWeeklyHours.fluctuating] = data[IWeeklyHours.fluctuating];
  }

  getHours() {
    return this[IWeeklyHours.hours];
  }

  isFluctuating() {
    return this[IWeeklyHours.fluctuating] === true;
  }
}
